var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.81,59.86c0-8.76,13.38-15.86,29.7-15.86s29.68,7.1,29.68,15.86v4.79c0,1.02-.83,1.84-1.84,1.84H9.66c-1.02,0-1.84-.83-1.84-1.84v-4.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.51,11.5c6.48,0,11.75,5.27,11.75,11.75s-5.27,11.75-11.75,11.75-11.75-5.27-11.75-11.75,5.27-11.75,11.75-11.75m0-3c-8.15,0-14.75,6.6-14.75,14.75s6.6,14.75,14.75,14.75,14.75-6.6,14.75-14.75-6.6-14.75-14.75-14.75h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/__User.c81e5f815741e60d4c65ce363bdd960d.svg";
export { ForwardRef as ReactComponent };